import React, { lazy } from 'react';
import { School, Building2, Globe2 } from 'lucide-react';
export const WhoWeTrain = () => {
  const audiences = [{
    title: 'Schools',
    icon: <School className="w-10 h-10 text-white" data-id="element-1348" />,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg',
    items: ['Teacher development', 'Student leadership programs', 'School communications teams']
  }, {
    title: 'Companies & Startups',
    icon: <Building2 className="w-10 h-10 text-white" data-id="element-1349" />,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg',
    items: ['Marketing teams', 'Leadership teams', 'HR teams', 'Professional development']
  }, {
    title: 'Organizations & NGOs',
    icon: <Globe2 className="w-10 h-10 text-white" data-id="element-1350" />,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg',
    items: ['Program teams', 'Communications teams', 'Community managers', 'Project teams']
  }];
  return <section className="py-20 bg-white border-y border-gray-100" data-id="element-1351">
      <div className="container mx-auto px-4" data-id="element-1352">
        <div className="text-center mb-16 scroll-animate" data-id="element-1353">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1354">
            Who We Train
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1355">
            Tailored capacity building for diverse institutional needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1356">
          {audiences.map((audience, index) => <div key={index} className="scroll-animate relative rounded-2xl overflow-hidden group hover:shadow-xl transition-all duration-300 min-h-[380px] flex flex-col justify-end" style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-1357">
              {/* Background image */}
              <img src={audience.image} alt={audience.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" data-id="element-1358" />
              {/* Dark overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/50 to-black/20" data-id="element-1359"></div>

              {/* Content */}
              <div className="relative z-10 p-8" data-id="element-1360">
                <div className="w-14 h-14 bg-white/15 backdrop-blur-sm rounded-xl flex items-center justify-center mb-5 border border-white/20" data-id="element-1361">
                  {audience.icon}
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1362">
                  {audience.title}
                </h3>
                <ul className="space-y-3" data-id="element-1363">
                  {audience.items.map((item, i) => <li key={i} className="flex items-center text-gray-200" data-id="element-1364">
                      <span className="w-1.5 h-1.5 rounded-full bg-gold mr-3 flex-shrink-0" data-id="element-1365"></span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};